import React, { ReactNode } from 'react';

import { useModalsContext } from '../../contexts/ModalsContext';
import ElementPortal from './ElementPortal';

interface ModalPortalProps {
    id?: string;
    data?: Record<string, unknown>;
    children?: ReactNode;
}

const ModalPortal = ({ id = null, data = null, children = null }: ModalPortalProps) => {
    const { container, register = null, unregister = null } = useModalsContext();
    return (
        <ElementPortal
            id={id}
            data={data}
            container={container}
            register={register}
            unregister={unregister}
        >
            {children}
        </ElementPortal>
    );
};

export default ModalPortal;
